import PeriodScheduleItem from '@api/models/period-schedule-item';

/**
 * Prefer voyage tcTerms period schedule when present (fixed contract),
 * otherwise fall back to fixture tcTerms schedule (estimate).
 */
const getEffectivePeriodScheduleItems = (
	fixtureTcTerms: { PeriodScheduleItems: PeriodScheduleItem[] },
	voyageTcTerms?: { PeriodScheduleItems?: PeriodScheduleItem[] } | null,
): PeriodScheduleItem[] => {
	if (voyageTcTerms?.PeriodScheduleItems != null && voyageTcTerms.PeriodScheduleItems.length > 0) {
		return voyageTcTerms.PeriodScheduleItems;
	}

	return fixtureTcTerms.PeriodScheduleItems;
};

export default getEffectivePeriodScheduleItems;
